import { render, staticRenderFns } from "./WineryList.vue?vue&type=template&id=6da99ba1&scoped=true&"
import script from "./WineryList.vue?vue&type=script&lang=ts&"
export * from "./WineryList.vue?vue&type=script&lang=ts&"
import style0 from "./WineryList.vue?vue&type=style&index=0&id=6da99ba1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da99ba1",
  null
  
)

export default component.exports